import { ThemeProvider } from "@mui/material/styles";
import _ from "lodash";
import React, { createRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import * as providerActionCreators from "./actions";
import { log } from "../../Helper";
import * as spinnerStateActionCreator from "../../formControl/actions";
import AvisPageHeader from "./avisHeader/avisHeader";
import AvisPageDialog from "./avisDialog/avisDialog";
import AvisMaterialTable from "./avisMaterialTable/avisMaterialTable";
import LoaderComponent from "../../LoaderComponent/LoaderComponent";
import { AvisTableData, deleteSORequest } from "./api";
import {
  theme,
  notify_failed_multipleLocation,
  notify_failed_multipleShipping,
} from "./utility/constants";
import { useUserInfo } from "../../common/user-context";
import { useComarFilter } from "../../hooks/useComarFilter";
import FilterHeader from "../../components/FilterHeader";

const tableRef = createRef();

const Orders = () => {
  const { userData } = useUserInfo();
  //importing actions

  const {
    setProvider,
    triggerLoadBuildActionByAvis,
  } = bindActionCreators(providerActionCreators, useDispatch());

  const { setSpinnerState } = bindActionCreators(
    spinnerStateActionCreator,
    useDispatch()
  );

  //useStates

  //error flag to validate all the scenario to mark machine ready for pick-up.
  const [errorFlag, setErrorFlag] = useState(false);
  //handle modal operations
  const [open, setOpen] = React.useState(false);
  const [isLoadBuildDialogOpen, setIsLoadBuildDialogOpen] = useState(false);
  const [openDeleteSO, setOpenDeleteSO] = useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  //use related
  const [isInternal, setIsInternal] = useState(false);
  const [deleteSOAccess, setDeleteSOAccess] = useState(false);
  const [selectedMachinesForBuild, setSelectedMachinesForBuild] = useState([]);
  const [selectedMachinesForDeleteSO, setselectedMachinesForDeleteSO] =
    useState([]);
  const [avisLoadBuildValidatorState, setAvisLoadBuildValidatorState] =
    useState(false);
  //material table related
  const [pageSize] = useState(1000);
  const [pageNumber, setPageNumber] = useState(0);
  const [tableData, setTableData] = useState(Array(0));
  const [originalTableData, setOriginalTableData] = useState(Array(0));
  
  // Use reusable COMAR filter hook
  const {
    isFiltered,
    filterSource,
    filterTitle,
    totalFilteredOrders,
    filteredData,
    clearFilter
  } = useComarFilter(originalTableData, 'zcomar'); // AVIS uses zcomar field

  // Update tableData whenever filteredData changes
  useEffect(() => {
    setTableData(filteredData);
  }, [filteredData]);

  const [imoList, setImoList] = useState(Array(0));
  const [locationList, setLocationList] = useState(Array(0));
  const [uniqueTruckDetailsDTOList, setUniqueTruckDetailsDTOList] = useState(
    Array(0)
  );
  const [isLoading, setLoading] = useState(false);
  const [previousForwarder, setPreviousForwarder] = React.useState();

  // all the setStates
  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseDeleteSO = () => {
    setOpenDeleteSO(false);
  };

  const handleCloseLoader = () => {
    setOpenLoader(false);
  };
  const deleteSO = (data) => {
    setselectedMachinesForDeleteSO(data);
    setOpenDeleteSO(true);
  };

  //all the selectors

  const providerList = useSelector((storeState) => storeState.getProviderList);
  const supplierId_withForwarder = userData.supplierNumber;
  const supplierName = userData.descr;
  let supplierId_WithInternal = useSelector(
    (storeState) => storeState.setProvider
  );
  const authorities = userData.authorities;

  let avisLoadBuildValidator = useSelector(
    (storeState) => storeState.avisLoadBuildValidator
  );
  let spinnerState = useSelector((storeState) => storeState.spinnerState);

  // log("user auth for AVIS--->", authorities);

  //material table columns

  const columns = [
    {
      title: "FROM",
      field: "from",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
        textAlign: "center",
      },
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: "SHIP ORDER",
      field: "shpOrder",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
        textAlign: "center",
      },
      cellStyle: {
        textAlign: "left",
      },
    },
    {
      title: "LOAD BUILD",
      field: "loadbuild",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
        textAlign: "center",
      },
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: "PLANNED LOADING DATE",
      field: "asn",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
        textAlign: "center",
      },
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: "TO COUNTRY",
      field: "toCountry",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
        textAlign: "center",
      },
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: "TO CITY",
      field: "toCity",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
        textAlign: "center",
      },
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: "",
      field: "build",
      hidden: true,
    },
    {
      title: "COMAR",
      field: "zcomar",
      headerStyle: {
        fontSize: "12px",
        textAlign: "center",
      },
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: "",
      field: "colorcode",
      hidden: false,
      filtering: false,
      width: 30,
      headerStyle: {
        textAlign: "center",
        width: 30,
      },
      cellStyle: {
        textAlign: "center",
        padding: "4px",
      },
    },
    {
      title: "DOCS",
      field: "links",
      sorting: false,
      filtering: false,
      width: 80,
      headerStyle: {
        fontSize: "12px",
        textAlign: "center",
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
        padding: "4px",
      },
    },
    {
      title: "",
      field: "statusText",
      hidden: true,
      filtering: false,
    },
    {
      field: "delete",
      sorting: false,
      hidden: deleteSOAccess ? false : true,
      width: 50,
      filtering: false,
      headerStyle: {
        textAlign: "center",
        width: 50,
      },
      cellStyle: {
        textAlign: "center",
        padding: "4px",
      },
    },
    {
      title: "",
      field: "arrivalDate",
      hidden: true,
      filtering: false,
    },
    {
      title: "",
      field: "estimatedArrivalDate",
      hidden: true,
      filtering: false,
    },
    {
      title: "",
      field: "departureDate",
      hidden: true,
      filtering: false,
    },
  ];

  // all the handle functions

  const handleApply = (data) => {
    triggerLoadBuildActionByAvis(true);
    setAvisLoadBuildValidatorState(false);
  };

  const handleDeleteSOYes = (data) => {
    let id = isInternal ? userData.userId : supplierId_withForwarder;
    handleCloseDeleteSO();
    setOpenLoader(true);
    const reqObj = {
      buildId: selectedMachinesForDeleteSO.buildId,
      userId: id,
      comarList: [selectedMachinesForDeleteSO.zcomar],
      docTypeList: ["SO"],
      authorities: authorities,
    };
    deleteSORequest(reqObj, handleCloseLoader, handleTableRefresh);
  };

  const handleClickOpen = (data) => {
    log("Selected machines in avis ", data);
    for (let i = 0; i < data.length; i++) {
      if (!_.eq(data[0].from, data[i].from)) {
        notify_failed_multipleLocation(data[0].from, data[i].from);
        setErrorFlag(false);
        break;
      }
      if (!_.eq(data[0].shpOrder, data[i].shpOrder)) {
        notify_failed_multipleShipping(data[0].shpOrder, data[i].shpOrder);
        setErrorFlag(false);
        break;
      }
    }
    if (errorFlag) {
    } else {
      setSelectedMachinesForBuild(data);
      setIsLoadBuildDialogOpen(true);
      setOpen(true);
    }
  };
  const handleTableRefresh = () => {
    // tableRef.current.state.query.orderBy = null;
    // tableRef.current.state.query.orderDirection = "";
    getTableData();
  };
  const getTableData = async () => {
    setLoading(true);
    try {
      const supplierId = supplierId_WithInternal
        ? supplierId_WithInternal
        : supplierId_withForwarder;
      if (supplierId !== undefined || supplierId !== null) {
        const response = await AvisTableData(
          supplierId,
          pageSize,
          pageNumber,
          deleteSO
        );
        log("AVIS response-- ", response);
        setOriginalTableData(response.tableData);
        setImoList(response.imolist);
        setLocationList(response.locationList);
        setUniqueTruckDetailsDTOList(response.tableData.truckDetailsDTOList);
      }
    } catch (error) {
      setOriginalTableData(Array(0));
    }
    setLoading(false);
  };

  //useEffects (async operations)

  // To handle dialog close/open on form submit button click
  useEffect(() => {
    log("avisLoadBuildValidatorState", avisLoadBuildValidatorState);
    log("spinnerState to close spinner", spinnerState);
    if (avisLoadBuildValidatorState === true && spinnerState === false) {
      log("Close the dialog one more ", open);
      handleTableRefresh();
      setIsLoadBuildDialogOpen(false);
      log("Close the dialog", open);
      setOpen(false);
      setSpinnerState(true);
    } else {
      if (isLoadBuildDialogOpen) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    }
  }, [avisLoadBuildValidatorState, spinnerState, isLoadBuildDialogOpen]);

  useEffect(() => {
    setIsInternal(userData.internal);
    if (!_.isEqual(previousForwarder, supplierId_WithInternal)) {
      setPreviousForwarder(supplierId_WithInternal);
    }
  });

  useEffect(() => {
    if (
      authorities &&
      (authorities.includes("ROLE_FULL_APPLICATION_ACCESS") ||
        authorities.includes("ROLE_AVIS_BUILD_DELETE_ACCESS"))
    ) {
      setDeleteSOAccess(true);
    }

    setAvisLoadBuildValidatorState(avisLoadBuildValidator);
  });

  useEffect(() => {
    getTableData();
  }, [previousForwarder]);

  return (
    <div className="rounded-sm">
      <AvisPageHeader
        isInternal={isInternal}
        setProvider={setProvider}
        providerList={providerList}
        supplierName={supplierName}
        handleTableRefresh={handleTableRefresh}
        isFiltered={isFiltered}
        filterTitle={filterTitle}
        totalFilteredOrders={totalFilteredOrders}
        onClearFilter={clearFilter}
        filterSource={filterSource}
      />
      
      <ThemeProvider theme={theme}>
        {isLoading && <LoaderComponent />}
        {!isLoading && (
          <AvisMaterialTable
            tableName="Avis"
            tableRef={tableRef}
            columns={columns}
            supplierId_WithInternal={supplierId_WithInternal}
            supplierId_withForwarder={supplierId_withForwarder}
            deleteSO={deleteSO}
            handleClickOpen={handleClickOpen}
            previousForwarder={previousForwarder}
            setPageNumber={setPageNumber}
            tableData={tableData}
            handleTableRefresh={handleTableRefresh}
          />
        )}
        <AvisPageDialog
          open={open}
          handleClose={handleClose}
          handleApply={handleApply}
          openDeleteSO={openDeleteSO}
          handleCloseDeleteSO={handleCloseDeleteSO}
          selectedMachinesForDeleteSO={selectedMachinesForDeleteSO}
          handleDeleteSOYes={handleDeleteSOYes}
          selectedMachinesForBuild={selectedMachinesForBuild}
          uniqueTruckDetailsDTOList={uniqueTruckDetailsDTOList}
          imoList={imoList}
          locationList={locationList}
          openLoader={openLoader}
          handleCloseLoader={handleCloseLoader}
        />
      </ThemeProvider>
    </div>
  );
};
export default Orders;
